import { globalStyles } from 'shared/constants';
const { display, flex, width, cursor, padding } = globalStyles;

const dashboardStyles = {
  appBar: {
    background: 'transparent',
  },
  textField: {
    width: 412,
    "& .MuiOutlinedInput-root": {
      backgroundColor: "grey.100",
    },
  },
  circularProgress: {
    color: 'grey.600'
  },
  syncIcon: {
    fontSize: 96,
  },
  paper: {
    '& .MuiDialog-paper': {
      maxWidth: 416,
    }
  },
  downloadDialogPaper: {
    '& .MuiDialog-paper': {
      maxWidth: 416,
      minWidth: 416,
    }
  },
  downloadProgressBar: {
    backgroundColor: 'grey.200',
  },
  reuploadLabel: {
    color: 'grey.500'
  },
  syncDialogCloseIcon: {
    color: 'grey.400'
  },
  syndErrorIcon: {
    marginTop: 16,
    height: 64,
  }
};

export default dashboardStyles;
